export const ActivationFinished: Page = () => {
    return <div>ユーザーの有効化が完了しました!</div>
}

ActivationFinished.path = "/activation_finished"
